export default __webpack_public_path__ + "static/media/feature_4@3x.742becbd.png";